import { render, staticRenderFns } from "./AppPruvo.vue?vue&type=template&id=1bf63a6b&"
import script from "./AppPruvo.vue?vue&type=script&lang=js&"
export * from "./AppPruvo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports